// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marker[data-v-cbb17124]{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:linear-gradient(180deg,hsla(0,0%,49%,.24),hsla(0,0%,73%,.16))}.marker[data-v-cbb17124]:before{filter:drop-shadow(0 4px 24px rgba(0,0,0,.16));transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
